<div
  class="tw-flex tw-flex-col tw-bg-dt-surface-elevated tw-rounded-2xl tw-overflow-hidden tw-w-full tw-h-full"
>
  <!-- Header -->
  <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-px-6 tw-pt-6 tw-pb-4">
    <span class="tw-font-semibold tw-text-xl tw-text-dt-text-headings">
      {{ "addBillAlert" | i18n }}
    </span>
    <button
      type="button"
      class="tw-absolute tw-right-4 tw-top-4 tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-bg-dt-surface-elevated tw-shadow-card-elevated"
      (click)="close()"
    >
      <icon [name]="'close'" [size]="4" [currentColor]="'neutral-600'"></icon>
    </button>
  </div>

  <!-- Form Body -->
  <form [formGroup]="form" class="tw-flex tw-flex-col tw-flex-1 tw-gap-6 tw-px-6 tw-py-6">
    <!-- Payment Type -->
    <app-dropdown-select
      [label]="'paymentType' | i18n"
      [isRequired]="true"
      [options]="paymentTypeOptions"
      [placeholder]="'select' | i18n"
      [selectedOption]="selectedPaymentType"
      [customShadowClass]="'tw-shadow-elevation-input'"
      [showGradientBorder]="false"
      [manualTouched]="isTouched"
      [sort]="'date'"
      (optionSelected)="onPaymentTypeSelected($event)"
    ></app-dropdown-select>

    <!-- Payee -->
    <app-input
      [label]="'payee' | i18n"
      [placeholder]="'enterPayeeName' | i18n"
      [isRequired]="true"
      [manualTouched]="isTouched"
      formControlName="payee"
    ></app-input>

    <!-- Due Date + Amount -->
    <div class="tw-flex tw-gap-3">
      <div class="tw-flex-1">
        <app-date-picker
          [label]="'billDueDate' | i18n"
          [isRequired]="true"
          [hasError]="isTouched && !selectedDueDate"
          [hasIcon]="true"
          [restrictToFuture]="true"
          (changeDateEvent)="onDueDateChanged($event)"
        ></app-date-picker>
      </div>
      <div class="tw-flex-1">
        <app-input
          [label]="'billAmount' | i18n"
          type="number"
          placeholder="0.00"
          [isRequired]="false"
          [manualTouched]="isTouched"
          formControlName="amount"
        ></app-input>
        @if (isTouched && form.controls["amount"].invalid) {
          <span class="tw-text-xs tw-text-dt-text-error">{{
            "billAmountMustBePositive" | i18n
          }}</span>
        }
      </div>
    </div>

    <!-- Notification Date (pill chips) -->
    <div class="tw-flex tw-flex-col tw-gap-2">
      <div class="tw-flex tw-gap-1 tw-font-bold tw-text-dt-text-tertiary tw-text-[12px]">
        <span>{{ "notificationDate" | i18n }}</span>
        <span class="tw-text-sm">*</span>
      </div>
      <div class="tw-flex tw-gap-2">
        @for (option of notifyOptions; track option.days) {
          <button
            type="button"
            class="tw-px-5 tw-py-2 tw-rounded-full tw-text-sm tw-font-medium tw-transition-colors"
            [ngClass]="
              isNotifyDaySelected(option.days)
                ? 'tw-bg-dt-custom-teal-9 tw-text-dt-text-contrast tw-shadow-inner'
                : 'tw-bg-dt-surface-elevated tw-text-dt-text-headings tw-shadow-card-elevated'
            "
            (click)="selectNotifyDays(option.days)"
          >
            {{ option.label }}
          </button>
        }
      </div>
      @if (isTouched && selectedNotifyDays.length === 0) {
        <span class="tw-text-xs tw-text-dt-text-error">{{
          "pleaseSelectNotificationDate" | i18n
        }}</span>
      }
    </div>

    <!-- Save Button -->
    <div class="tw-flex tw-justify-end tw-mt-8 tw-pt-2">
      <button
        type="button"
        class="tw-px-8 tw-py-3 tw-rounded-full tw-bg-dt-custom-teal-9 tw-text-dt-text-contrast tw-font-semibold tw-text-base tw-shadow-button"
        (click)="save()"
      >
        {{ "save" | i18n }}
      </button>
    </div>
  </form>
</div>
